import { NgModule, Component } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './auth/login/login.component';
import { HomeComponent } from './public/home/home.component';
import { PagenotfoundComponent } from './public/pagenotfound/pagenotfound.component';
import { ApplicationFormComponent } from './public/application/application-form.component';
import { InstitutionComponent } from './public/institution/institution.component';
import { ProgramComponent } from './public/program/program.component';
import { MasterdataComponent } from './public/masterdata/masterdata.component';
import { ModuleComponent } from './public/module/module.component';
import { StudentRegistrationComponent } from './public/student-registration/student-registration.component';
import { SponserComponent } from './public/sponser/sponser.component';
import { GradeComponent } from './public/grade/grade.component';
import { StudentsTableComponent } from './private/tables/students-table/students-table.component';
import { ApplicationTableComponent } from './private/tables/application-table/application-table.component';

import { UserComponent } from './public/user/user.component';
import { UsermasterComponent } from './public/usermaster/usermaster.component';
import { DashboardComponent } from './public/dashboard/dashboard.component';
import { ExaminationComponent } from './public/examination/examination.component';
import { SubjectTableComponent } from './private/tables/subject-table/subject-table.component';
import { ExaminationTableComponent } from './private/tables/examination-table/examination-table.component';
import { SubjectComponent } from './public/subject/subject.component';
import { UploadstudentComponent } from './public/uploadstudent/uploadstudent.component';
import { UploadmarkComponent } from './public/uploadmark/uploadmark.component';
import { TempstudentTableComponent } from './private/tables/tempstudent-table/tempstudent-table.component';
import { TempexamTableComponent } from './private/tables/tempexam-table/tempexam-table.component';
import { MarksTableComponent } from './private/tables/marks-table/marks-table.component';
import { MarksComponent } from './public/marks/marks.component';
import { ProfileComponent } from './public/profile/profile/profile.component';
import { PasswordresetComponent } from './public/profile/passwordreset/passwordreset.component';
import { CertificateComponent } from './public/print/certificate/certificate.component';
import { MarkListComponent } from './public/print/mark-list/mark-list.component';
import { GradingComponent } from './public/grading/grading.component';
import { RolesComponent } from './public/roles/roles.component';
import { OrganisationComponent } from './public/organisation/organisation.component';
import { OrganisationTableComponent } from './private/tables/organisation-table/organisation-table.component';
import { TranscriptComponent } from './public/print/transcript/transcript.component';
import { TranscriptTableComponent } from './private/tables/transcript-table/transcript-table.component';
import { UserTableComponent } from './private/tables/user-table/user-table.component';
import { DialogueboxComponent } from './public/dialoguebox/dialoguebox.component';
import { DecisionComponent } from './public/decision/decision.component';
import { DialogboxComponent } from './public/dialogbox/dialogbox.component';
import { CrystalreportsComponent } from './private/widget/crystalreports/crystalreports.component';


const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'home', component: HomeComponent },
  // { path: 'master_table', loadChildren: () => import('./public/masterdata/masterdata.component').then(m => m.MasterdataComponent) },

  { path: 'login', component: LoginComponent },
  { path: 'application', component: ApplicationFormComponent },
  { path: 'Institution', component: InstitutionComponent },
  { path: 'Program', component: ProgramComponent },
  { path: 'studentregistration', component: StudentRegistrationComponent },
  { path: 'grade', component: GradeComponent },
  { path: 'user', component: UserComponent },

  { path: 'usermaster', component: UsermasterComponent },
  { path: 'studentstable', component: StudentsTableComponent },
  { path: 'applicationtable', component: ApplicationTableComponent },
  { path: 'tempstudenttable', component: TempstudentTableComponent },
  { path: 'tempexamtable', component: TempexamTableComponent },
  { path: 'master_table', component: MasterdataComponent },
  { path: 'dashboard', component: DashboardComponent },
  { path: 'examination', component: ExaminationComponent },
  { path: 'examinationtable', component: ExaminationTableComponent },
  { path: 'subjects', component: SubjectTableComponent },
  { path: 'subject', component: SubjectComponent },
  { path: 'subjectRegistration', component: SubjectComponent },
  { path: 'uploadstudent', component: UploadstudentComponent },
  { path: 'markstable', component: MarksTableComponent },
  { path: 'marks', component: MarksComponent },
  { path: 'uploadmark', component: UploadmarkComponent },
  { path: 'profile', component: ProfileComponent },
  { path: 'reset-password', component: PasswordresetComponent },
  { path: 'certificate', component: CertificateComponent },
  { path: 'marklist', component: MarkListComponent },
  { path: 'grading', component: GradingComponent },
  { path: 'roles', component: RolesComponent },
  { path: 'transcripttable', component: TranscriptTableComponent },
  { path: 'usertable', component: UserTableComponent },
  { path: 'dialog', component: DialogueboxComponent },
  { path: 'decision', component: DecisionComponent },
  { path: 'report/:id', component: CrystalreportsComponent },
  { path: '**', component: PagenotfoundComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  entryComponents: [DialogboxComponent],
  exports: [RouterModule]
})
export class AppRoutingModule { }
export const routingComponent = [
  LoginComponent,
  HomeComponent,

  PagenotfoundComponent,
  ApplicationFormComponent,
  InstitutionComponent,
  ProgramComponent,
  ModuleComponent,
  UserComponent,
  SponserComponent,
  StudentRegistrationComponent,
  GradeComponent,
  MasterdataComponent,
  StudentsTableComponent,
  DashboardComponent,
  ExaminationComponent,
  SubjectTableComponent,
  ExaminationTableComponent,
  SubjectComponent,
  UploadstudentComponent,
  UploadmarkComponent,
  TempstudentTableComponent,
  TempexamTableComponent,
  MarksTableComponent,
  ProfileComponent,
  PasswordresetComponent,
  CertificateComponent,
  MarkListComponent,
  GradingComponent,
  RolesComponent,
  MarksComponent,
  OrganisationComponent,
  OrganisationTableComponent,
  TranscriptComponent,
  TranscriptTableComponent,
  UserTableComponent,
  DialogueboxComponent,
  DecisionComponent,
  CrystalreportsComponent,
  DialogboxComponent

];
